module.exports = __webpack_public_path__ + "media/images/amenities_icons/dog_friendly-f273844726caedfcce093042d85e2a72.svg";